// extracted by mini-css-extract-plugin
export default {"dialog-bg":"SOzI8_dialog-bg"};